import { useEffect } from "react";

// Sets the page title and meta description for the route being viewed.
// Every page used to inherit the site-wide homepage title, which meant Google
// had nothing telling it that a category page is about that category — the
// main reason a page like "Halal Meat" could never rank for its own term.
//
// Shared by the product, category and subcategory pages so the three don't
// drift apart.
export default function usePageSeo({ title, description }) {
  useEffect(() => {
    if (!title && !description) return;

    if (title) document.title = title;

    if (description) {
      let meta = document.querySelector("meta[name='description']");
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [title, description]);
}

// Google truncates a title around 60 characters; cutting on a word boundary
// keeps the tail readable instead of ending mid-word.
function clip(text, max) {
  if (text.length <= max) return text;
  const cut = text.slice(0, max);
  const lastSpace = cut.lastIndexOf(" ");
  return (lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut).trim();
}

// Falls back to a keyword-shaped title built from the name, so all 44
// categories and subcategories improve immediately rather than only the ones
// an admin has got round to writing copy for.
export function categorySeo(entity, kind = "category") {
  if (!entity?.name) return {};
  const name = entity.name;
  // Several categories are already called "Halal …", and the generic template
  // would then read "Halal Halal Meat".
  const alreadyHalal = /halal/i.test(name);
  const subject = alreadyHalal ? name : `Halal ${name}`;

  const title = entity.seo_title
    || (kind === "subcategory"
      ? `Buy ${name} Online in Korea | FMart Korea`
      : `${name} | FMart Korea — Halal Grocery Delivery`);

  const description = entity.seo_meta_description
    || (entity.description && entity.description.length > 40 ? entity.description : "")
    || `Buy ${subject} online at FMart Korea. Halal certified, fresh stock and fast delivery across South Korea. 한국 전역 배송.`;

  return { title: clip(title, 65), description: clip(description, 300) };
}
